import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';


export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.01) 100%);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.30);
  backdrop-filter: blur(25px);
  width: 100%;

  ${mediaQuery.minWidth.tablet} {
    &:nth-child(1) {
      margin-top: 0;
    }
  
    &:nth-child(2) {
      margin-top: 93px;
    }
    
    &:nth-child(3) {
      margin-top: 185px;
    }
  }

`;

export const Image = styled.img`
  height: 240px;
  width: 100%;
  object-fit: cover;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 28px 32px 48px 32px;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  letter-spacing: -0.32px;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 1.25rem;
  }
`;

export const ItalicTitle = styled.span`
  font-style: italic;
`;

export const Description = styled.div`
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;